/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * BankAccount without TransferFeeCondition
 * @export
 * @interface SearchBankTransfers200ResponseInnerSourceBankAccount
 */
export interface SearchBankTransfers200ResponseInnerSourceBankAccount {
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'accountType': SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof SearchBankTransfers200ResponseInnerSourceBankAccount
     */
    'companyName': string;
}

export const SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum = typeof SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum[keyof typeof SearchBankTransfers200ResponseInnerSourceBankAccountAccountTypeEnum];


